import { render, staticRenderFns } from "./EmailUpdateDialog.vue?vue&type=template&id=5a6643ac&scoped=true"
import script from "./EmailUpdateDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./EmailUpdateDialog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./EmailUpdateDialog.vue?vue&type=style&index=0&id=5a6643ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6643ac",
  null
  
)

export default component.exports